export default {"src":"/_next/static/media/varicose-veins-icon.07d28d8d.svg","height":396,"width":400,"blurWidth":0,"blurHeight":0};